import Vue from 'vue'
import VueRouter from "vue-router"
import store from './store'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

const routes = [
	{
		path: '/',
		name: 'home',
		component: () => import('./views/home/index'),
	},
	{
		path: '/register',
		name: 'register',
		component: () => import('./views/register/register'),
	},
	{
		path: '/query',
		name: 'query',
		component: () => import('./views/query/index')
	},
	{
		path: '/contentList/:id',
		name: 'ContentList',
		props: true,
		component: () => import('./views/contentList/index')
	},
	{
		path: '/meetList',
		name: 'MeetList',
		component: () => import('./views/meetList/index')
	},
	{
		path: '/meetList/:id',
		name: 'MeetListInfo',
		props: true,
		component: () => import('./views/meetList/info')
	},
	{
		path: '/notice',
		name: 'Notice',
		component: () => import('./views/notice/info')
	},

	// 个人中心
	{
		path: '/userCenter',
		name: 'userCenter',
		redirect: '/userCenter/userInfo',
		component: () => import('./views/userCenter/userCenter'),
		children: [{
			path: 'userInfo',
			name: "userInfo",
			component: () => import('./views/userCenter/compoments/userInfo'),
			meta: {
				requiredLogin: true
			}
		}, {
			path: 'pay',
			name: 'pay',
			component: () => import('./views/userCenter/compoments/pay'),
			meta: {
				requiredLogin: true
			}
		}, {
			path: 'myAccount',
			name: 'myAccount',
			component: () => import('./views/userCenter/compoments/accountMember'),
			meta: {
				requiredLogin: true
			}
		}, {
			path: 'myCertificate',
			name: 'myCertificate',
			component: () => import('./views/userCenter/compoments/myCertificate'),
			meta: {
				requiredLogin: true
			}
		}, {
			path: 'payRecord',
			name: 'payRecord',
			component: () => import('./views/userCenter/compoments/payRecord'),
			meta: {
				requiredLogin: true
			}
		}, {
			path: 'myMessageList',
			name: 'myMessageList',
			component: () => import('./views/userCenter/compoments/myMessageList'),
			meta: {
				requiredLogin: true
			}
		}]
	}
]

const R = new VueRouter({
	mode: 'hash',
	routes,
})

R.beforeEach((to, from, next) => {
	const {isLogin} = store.state;
	const requiredLogin = to.meta.requiredLogin;
	// 跳转的页面相同禁止点击
	// if (to.path === from.path) return;

	if (requiredLogin) { // 跳转的页面需要登录
		if (isLogin) { // 查看是否登录过，如果登录过直接放行
			next();
		} else {  // 否则，显示登录框
			store.dispatch('setShowLoginPop', true);
			next('/')
		}
	} else { // 不需要登录直接放行
		next()
	}
})

export default R
